function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
const Touchable = /*#__PURE__*/React.forwardRef(({
  className,
  children,
  onClick,
  disabled,
  type,
  ...rest
}, ref) => {
  const getClassNames = () => {
    switch (type) {
      case 'primary':
        return styles.primary;

      case 'secondary':
        return styles.secondary;

      case 'success':
        return styles.success;

      case 'warning':
        return styles.warning;

      case 'danger':
        return styles.danger;

      case 'outlined':
        return styles.outlined;

      default:
        return undefined;
    }
  };

  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    ref: ref,
    disabled: disabled,
    onClick: onClick,
    className: classNames(styles.container, getClassNames(), className)
  }), children);
});
Touchable.displayName = 'Touchable';
export default Touchable;